export default __webpack_public_path__ + "static/media/EEFF-2020-para-pantalla.1c2d984a.webp";